export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5332.2daf7989.jpg";